"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlgoliaCustomDataKey = void 0;
var AlgoliaCustomDataKey;
(function (AlgoliaCustomDataKey) {
    AlgoliaCustomDataKey["DefaultPageFacets"] = "default_page_facets";
    AlgoliaCustomDataKey["PerPageFacets"] = "per_page_facets";
})(AlgoliaCustomDataKey = exports.AlgoliaCustomDataKey || (exports.AlgoliaCustomDataKey = {}));
//# sourceMappingURL=algoliaCustomDataKey.js.map